import { TranscricaoDetalhe } from '../../../../../interfaces/entities/Transcricao/TranscricaoDetalhe';
import { AtualizarTranscricaoRequest } from '../../../../../services/TranscricaoBeneficiarioService';
import { EditarProfissionalFormValues } from '../steps/EditarProfissionalModal';

const resolveLocalAtendimentoInformado = (detalhe: TranscricaoDetalhe): string =>
  detalhe.localInformado?.trim()
  || detalhe.descricaoLocalAtendimento?.trim()
  || detalhe.codLocalAtendimento?.trim()
  || '';

const resolveCodTipoNecessidAtend = (detalhe: TranscricaoDetalhe): string =>
  detalhe.codNecessidAtend?.trim()
  || detalhe.codTipoNecessidAtend?.trim()
  || 'PROGR';

const resolveIdUfConselhoInformado = (
  values: EditarProfissionalFormValues,
  detalhe: TranscricaoDetalhe,
): number | null => {
  if (values.idUfConselhoInformado !== '') {
    return values.idUfConselhoInformado;
  }

  if (detalhe.idUfConselhoInformado !== undefined && detalhe.idUfConselhoInformado !== null) {
    return detalhe.idUfConselhoInformado;
  }

  return null;
};

export const buildAtualizarTranscricaoPayload = (
  detalhe: TranscricaoDetalhe,
  values: EditarProfissionalFormValues,
): AtualizarTranscricaoRequest | null => {
  if (!detalhe.idTranscricao) return null;

  const idUfConselhoInformado = resolveIdUfConselhoInformado(values, detalhe);
  if (idUfConselhoInformado === null) return null;

  return {
    idTranscricao: detalhe.idTranscricao,
    localAtendimentoInformado: resolveLocalAtendimentoInformado(detalhe),
    nomeSolicitanteInformado: values.profissional,
    codigoConselhoInformado: values.codigoConselho,
    numeroConselhoInformado: values.registro,
    idUfConselhoInformado,
    idDiagCid: detalhe.idDiagCid,
    codTipoNecessidAtend: resolveCodTipoNecessidAtend(detalhe),
    observacao: detalhe.observacao ?? '',
  };
};
